import React from 'react'
import { connect } from 'react-redux'

class Editable extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			isClicked: false
		};
	}

	static defaultProps = {
		element: 'div',
		className: '',
		content: '',
		json: '',
		cap: 'edit_pages'
	}

	handleClick = () => {
		this.setState( {
			isClicked: true
		})
	}

	render() {
		const { isClicked } = this.state
		const isClickedClass = isClicked ? ' is-clicked' : ''
		const {
			id,
			element,
			className,
			content,
			cap,
			allMetaData,
			userCanEditPage,
			pageId
		} = this.props
		const Tag = `${element}`
		var userCanEditContent = false,
			parentId = this.props.parentId,
		    parentType,
		    saveLocation,
		    contentType,
		    isInline,
		    isPlain,
		    contentProp,
		    metaId,
		    meta

		if ( ! parentId ) {
			parentId = pageId
		}

		// if ( siteData.user_caps[ cap ] ) {
		// 	userCanEditContent = true
		// }

		if ( userCanEditPage && allMetaData ) {
			metaId = 'vl_' + id
			meta = allMetaData[ metaId ]

			if ( meta ) {
				userCanEditContent = meta.user_can_edit ? meta.user_can_edit : false
				parentType = meta.parent_type
				saveLocation = meta.save_location
				contentType = meta.type
				isInline = 'inline' === meta.type ? '1' : '0'
				isPlain = 'text' === meta.type ? '1' : '0'
				contentProp = isPlain ? content : ''
			}
		}

		if ( userCanEditContent ) {
			return (
				<Tag
					className={ className + ' is-editable' + isClickedClass }
					dangerouslySetInnerHTML={ { __html: content } }
					// data-id={ id }
					data-parent-type={ parentType }
					data-parent-id={ parentId }
					data-save-location={ saveLocation }
					data-content-id={ id }
					data-content={ contentProp }
					// data-parent-post-type={ parentPostType }
					data-is-inline={ isInline }
					data-is-plain={ isPlain }
					onClick={ this.handleClick }
				/>
			)
		} else {
			return (
				<Tag
					className={ className }
					dangerouslySetInnerHTML={ { __html: content } }
				/>
			)
		}
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let selected = state.page.selected,
		userCanEditPage = selected && selected.user_can_edit ? selected.user_can_edit : false,
		pageId = selected && selected.id ? selected.id : false

	return {
		allMetaData: state.content.metaData,
		userCanEditPage: userCanEditPage,
		pageId: pageId
	}
}

export default connect( mapStateToProps )( Editable )


// WEBPACK FOOTER //
// ./components/Editable/Editable.jsx